module.exports = "<div class=\"y-input-ctn y-simpleinput\" data-bind=\"css: ctnClass\">\n  <input class=\"y-input\" data-bind=\"\n      css: {'y-text-changed': enableChangingStyle && textChanged(), 'text-right': align === 'right'},\n      click: onClick,\n      event: {keyup: onKeyup, blur: onBlur, input: onInput, focus: onFocus},\n      attr: {maxlength: maxlength, type: type, placeholder: placeholder, disabled: disabled,fieldid: fieldid},\n      value: value\" />\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/input/simpleinput.html
// module id = 468
// module chunks = 0